import React from 'react';
import { Box, TextField } from '@mui/material';

export type TargetEntityType = 'lead' | 'account' | 'other';

export interface WebScrapingConfig {
  website_url: string;
  prompt: string;
}

export interface WebScrapingConfigFormProps {
  websiteUrl: string;
  targetProperties: string;
  targetEntity?: TargetEntityType;
  customEntityName?: string;
  onWebsiteUrlChange: (value: string) => void;
  onTargetPropertiesChange: (value: string) => void;
  onTargetEntityChange?: (value: TargetEntityType) => void;
  onCustomEntityNameChange?: (value: string) => void;
  disabled?: boolean;
  /** If true, shows compact layout without title/tooltip (for embedding in modals) */
  compact?: boolean;
  /** Optional info tooltip description */
  infoTooltip?: string;
}

const textFieldSx = (theme: any) => ({
  mt: 1,
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.customColors?.themePrimary
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.customColors?.themePrimary,
      borderWidth: '2px'
    }
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.customColors?.themePrimary
  }
});

const IMPORT_PLACEHOLDER = `"I want a list of exhibitors from this trade show page. For each exhibitor, I need: company name, contact email, and website link."

or 

"Scrape the speaker directory. For each speaker, get their name, job title, and company."`;

const WebScrapingConfigForm: React.FC<WebScrapingConfigFormProps> = ({
  websiteUrl,
  targetProperties,
  onWebsiteUrlChange,
  onTargetPropertiesChange,
  disabled = false
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Website to scrape"
        fullWidth
        value={websiteUrl}
        onChange={(e) => onWebsiteUrlChange(e.target.value)}
        placeholder="https://example.com/exhibitors"
        disabled={disabled}
        sx={textFieldSx}
      />

      <TextField
        label="What do you want to scrape?"
        fullWidth
        multiline
        minRows={4}
        value={targetProperties}
        onChange={(e) => onTargetPropertiesChange(e.target.value)}
        placeholder={IMPORT_PLACEHOLDER}
        helperText="Describe the list of items you want (e.g. exhibitors, companies, contacts) and for each item, explain which details you need (e.g. name, email, website). Write in simple English."
        disabled={disabled}
        sx={textFieldSx}
      />
    </Box>
  );
};

export default WebScrapingConfigForm;
